import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'rds-output-badge-status',
  templateUrl: './output-badge-status.component.html',
  styleUrls: ['./output-badge-status.component.scss']
})
export class OutputBadgeStatusComponent implements OnInit {

  @Input() status:string = 'hold';
  @Input() statusMapping:any = {};

  statusClass:string = 'hold';

  badgeMapping:any = {
    "success" : 'rds__badge-success',
    "hold": "rds__badge-secondary",
    "warning": "rds__badge-warning",
    "open" : "rds__badge-open",
    "error" : "rds__badge-error"
  };

  constructor() { }

  ngOnInit() {
    let badge:string = this.status ? (this.statusMapping[this.status.toLowerCase()] || 'hold') : 'hold';
    this.statusClass = this.badgeMapping[badge] || 'rds__badge-secondary';
  }


}
